import { useCallback, useState } from "react";
import { useNotify } from "react-admin";
import DownloadIcon from "@mui/icons-material/Download";
import { candidateRequests } from "api/candidateApi";
import LoadingActionButton from "server/components/LoadingActionButton";
import { getFileFromUrl } from "server/components/DownloadFile";
import { settings } from "app";
import { generateFileName } from "./utils";

const ExportExamResultsButton = ({ exam }) => {
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  const exportResults = useCallback(async () => {
    setLoading(true);
    const fileName = await generateFileName(exam);

    await getFileFromUrl(
      `${settings.gatewayApi}/${candidateRequests.exportCampaignExamResults(exam.campaignExamId)}`,
      fileName,
      notify,
    );

    setLoading(false);
  }, [notify, exam]);

  if (!exam) {
    return null;
  }

  return (
    <LoadingActionButton
      label="Изтегли оценки"
      icon={<DownloadIcon />}
      onClick={exportResults}
      loading={loading}
    />
  );
};

export default ExportExamResultsButton;
